var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-container",class:{'color-container--selected' : _vm.selected},attrs:{"id":_vm.id},on:{"click":_vm.emitColor}},[_c('div',{staticClass:"color-container--item",style:({'background-color' : _vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }